module.exports = __webpack_public_path__ + "img/Formula-new.2aac3c28.svg";